// extracted by mini-css-extract-plugin
export default {"title":"AuthenticationTitle_title__Jh4Nf"};